import { connect } from 'react-redux';
import BringYourOwnModem from '../../components/Plans/BringYourOwnModem/BringYourOwnModem';
import { PlansSelector } from '../reducers/PlansReducer';
import PlansAction from '../actions/PlansAction';

const mapStateToProps = state => ({
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
  isImportantInfoTickbox: PlansSelector.getIsImportantInfoTickboxSelected(state)
});
const mapDispatchToProps = dispatch => ({
  setByoModemSelected: (isSelected) => {
    dispatch(PlansAction.setByoModemSelected(isSelected));
  },
  handleChange: (isSelected) => {
    dispatch(PlansAction.setImportantInfoTickboxSelected(isSelected));
  }
});

const BringYourOwnModemContainer = connect(mapStateToProps, mapDispatchToProps)(BringYourOwnModem);

export default BringYourOwnModemContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/BringYourOwnModemContainer.js
 **/